module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('splitter', {
    attrs: {
      "config": _vm.splitterConfig,
      "showLeft": _vm.docsPanelIsOpen
    },
    on: {
      "resize": _vm.onResize
    }
  }, [_c('template', {
    slot: "left-pane"
  }, [_c('div', {
    staticClass: "docs",
    style: (_vm.docsPanelStyle)
  }, [_c('mwb-about')], 1)]), _vm._v(" "), _c('template', {
    slot: "right-pane"
  }, [_c('div', {
    staticClass: "content container-fluid"
  }, [_c('mwb-navigation'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe74402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 210
// module chunks = 5